import { HomepageProvider } from '../context/HomepageContext'
import ProgramsGrid from '../components/pages/ProgramsGrid'
import PageMeta from '../components/seo/PageMeta'
import { useProgramsData } from '../hooks/useProgramsData'

function ProgramsPageContent() {
  const { heading } = useProgramsData()

  return (
    <>
      <PageMeta title={heading.title} description={heading.subtitle} path="/programs" />

      <div className="relative overflow-hidden gradient-brand py-16 text-white sm:py-20">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute -end-20 top-0 h-64 w-64 rounded-full bg-accent blur-3xl" />
        </div>
        <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6">
          <p className="mb-3 text-sm font-semibold uppercase tracking-widest text-accent">
            {heading.label}
          </p>
          <h1 className="text-4xl font-bold sm:text-5xl">{heading.title}</h1>
          {heading.subtitle && (
            <p className="mx-auto mt-4 max-w-2xl text-lg text-white/80">{heading.subtitle}</p>
          )}
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-20">
        <ProgramsGrid />
      </div>
    </>
  )
}

export default function ProgramsPage() {
  return (
    <HomepageProvider>
      <article className="header-offset">
        <ProgramsPageContent />
      </article>
    </HomepageProvider>
  )
}
